import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

/**
 * 阻止在上传或同步过程中离开页面
 * @param {boolean} isUploading - 是否正在上传/同步
 * @param {string} message - 导航拦截时显示的确认消息
 */
export default function useUploadProtection(
  isUploading,
  message = "Upload is in progress. Leaving the page may cancel the upload. Continue?",
) {
  const navigationContext = useContext(UNSAFE_NavigationContext);
  const navigator = navigationContext?.navigator;

  // 阻止浏览器窗口/标签页关闭或刷新
  useEffect(() => {
    if (!isUploading) return;

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isUploading]);

  // 阻止 React Router 内部导航
  useEffect(() => {
    if (!isUploading) return undefined;
    if (!navigator || typeof navigator.block !== "function") return undefined;

    const unblock = navigator.block((tx) => {
      const confirmLeave = window.confirm(message);
      if (confirmLeave) {
        unblock();
        tx.retry();
      }
    });

    return unblock;
  }, [navigator, isUploading, message]);
}
